import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectStyleByRecord } from 'PDF/helpers/documentStyle';

interface ISectionTitleHeader {
  number: string;
  title: string;
}

const colorIndexes = {
  green: 7,
  blue: 0,
  red: 0,
  blueGreen: 6,
  blueRed: 0,
  blueYellow: 0,
};

export const SectionTitleHeader = ({ number, title }: ISectionTitleHeader) => (
  <View style={styles.sectionTitleWrapper} fixed>
    <Text>
      <Text style={[styles.sectionNumber, getColorObjectStyleByRecord(colorIndexes, 'color')]}>{`${number} `}</Text>
      <Text style={styles.sectionText}>{title}</Text>
    </Text>
  </View>
);

const styles = StyleSheet.create({
  sectionTitleWrapper: {
    height: 37,
    borderRight: '0.5',
    borderColor: '#000',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    position: 'absolute',
    top: 0,
    right: 36,
    paddingRight: 4,
  },
  sectionNumber: {
    fontFamily: 'Noto',
    fontWeight: 600,
    fontSize: 7,
    marginRight: 2,
  },
  sectionText: {
    fontFamily: 'Noto',
    fontWeight: 300,
    fontSize: 7,
    color: '#000',
    marginRight: 5,
  },
});
